import { DatePipe, NgClass } from '@angular/common';
import { Component, computed, inject, input, LOCALE_ID } from '@angular/core';
import { LookupVTO } from '../../../../../../pages/admin-dashboard/admin-companies/admin-companies.model';
import { DateTimePipe } from '../../../../../../shared/utils/date-time.pipe';

@Component({
  selector: 'app-offer-details-tab',
  imports: [DatePipe, NgClass, DateTimePipe],
  templateUrl: './offer-details-tab.html',
  styleUrl: './offer-details-tab.scss',
})
export class OfferDetailsTab {
  private locale = inject(LOCALE_ID);
  isArabic = computed(() => this.locale.startsWith('ar'));
  offer = input.required<any>();

  getStatusClass(offerStatus: LookupVTO) {
    const id = offerStatus?.id;
    if (id === 1) return 'bg-green-100 text-green-700';
    if (id === 2) return 'bg-red-100 text-red-700';
    if (id === 3) return 'bg-gray-100 text-gray-500';
    return '';
  }
}
